import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const HashIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.3334 6.6665V5.33317H10.6667V2.6665H9.33335V5.33317H6.66669V2.6665H5.33335V5.33317H2.66669V6.6665H5.33335V9.33317H2.66669V10.6665H5.33335V13.3332H6.66669V10.6665H9.33335V13.3332H10.6667V10.6665H13.3334V9.33317H10.6667V6.6665H13.3334ZM9.33335 9.33317H6.66669V6.6665H9.33335V9.33317Z" />
  </Icon>
);

export default memo(HashIcon);
